import scrollTo from '@utils/scrollTo'

const validateList = validatorsList => {
  validatorsList.forEach(validator => {
    validator.touch()
  })

  const invalidEl = validatorsList.find(validator => validator.hasErrors())?.elRef

  if (invalidEl) {
    // invalidEl.focus()
    scrollTo(invalidEl, 100)

    return false
  }

  return true
}

export default validateList
